import { memo, splitProps } from '../helpers.mjs';
import { createRecipe, mergeRecipes } from './create-recipe.mjs';

const mainFn = /* @__PURE__ */ createRecipe('main', {}, [])

const mainVariantMap = {}

const mainVariantKeys = Object.keys(mainVariantMap)

export const main = /* @__PURE__ */ Object.assign(memo(mainFn.recipeFn), {
  __recipe__: true,
  __name__: 'main',
  __getCompoundVariantCss__: mainFn.__getCompoundVariantCss__,
  raw: (props) => props,
  variantKeys: mainVariantKeys,
  variantMap: mainVariantMap,
  merge(recipe) {
    return mergeRecipes(this, recipe)
  },
  splitVariantProps(props) {
    return splitProps(props, mainVariantKeys)
  },
  getVariantProps: mainFn.getVariantProps,
})